import React from "react";

const Footer = () => (
  <footer className={"dark-bg footer"}>
    <div className={"footer-top"}>
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-lg-4 m-15px-tb"}>
            <h2 className={"footer-title"}>Contact</h2>
            <ul className={"list-unstyled links-white footer-link-1"}>
              {/*<li>
                <a href={'https://wa.link/54kf4x'}>+52 1 22 2639 3038</a>
              </li>*/}
              <li>
                <a
                  href={
                    "https://www.google.com/maps/place/18.975434212081563,-98.26343509199464"
                  }
                >
                  Puebla, Mexico
                </a>
              </li>
              <li>
                <a href={"mailto:contacto@fstack.com.mx"}>
                  contacto@fstack.com.mx
                </a>
              </li>
            </ul>
          </div>
          <div className={"col-lg-4 col-6 m-15px-tb"}>
            <h2 className={"white-color footer-title"}>Social Media</h2>
            <div className={"row"}>
              <div
                className={
                  "icon-40 theme-bg-alt border-radius-50 theme-color social-media-link"
                }
              >
                <a
                  aria-label={"Facebook"}
                  target="_blank"
                  rel={"noopener noreferrer"}
                  href={"https://www.facebook.com/fullStackEngineering/"}
                >
                  <i className={"fab fa-facebook-f"} />
                </a>
              </div>
              <div
                className={
                  "icon-40 theme-bg-alt border-radius-50 theme-color social-media-link"
                }
              >
                <a
                  aria-label={"LinkedIn"}
                  target="_blank"
                  rel={"noopener noreferrer"}
                  href={"https://www.linkedin.com/company/fullstack-mx/"}
                >
                  <i className={"fab fa-linkedin-in"} />
                </a>
              </div>
              <div
                className={
                  "icon-40 theme-bg-alt border-radius-50 theme-color social-media-link"
                }
              >
                <a
                  aria-label={"Instagram"}
                  target="_blank"
                  rel={"noopener noreferrer"}
                  href={"https://www.instagram.com/fullstack.mundial/"}
                >
                  <i className={"fab fa-instagram"} />
                </a>
              </div>
            </div>
            <ul className={"list-unstyled links-white footer-link-1"}>
              <li>
                <a
                  target="_blank"
                  rel={"noopener noreferrer"}
                  href={"https://fstack.com.mx/aviso-de-privacidad.pdf"}
                >
                  Notice of Privacy
                </a>
              </li>
            </ul>
          </div>
          <div className={"col-lg-4 m-15px-tb"}>
            <h2 className={"white-color footer-title"}>Blog</h2>
            <form>
              <div className={"flex-column flex-md-row m-5px-b white-color"}>
                <label htmlFor={"newsletter"}>Keep up to date</label>
                <input
                  id={"newsletter"}
                  type={"email"}
                  className={"form-control m-5px-r md-m-0px-r md-m-10px-b"}
                  placeholder={"Add your email"}
                />
                <br></br>
                <button
                  className={"m-btn m-btn-radius m-btn-green flex-shrink-0"}
                  type={"submit"}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div className={"footer-bottom border-style top light"}>
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-md-6 text-center text-md-right m-5px-tb"}></div>
          <div className="col-md-6 text-center text-md-right m-5px-tb">
            <p className="m-0px font-small white-color-light">
              © {new Date().getFullYear()} All rights reserved
            </p>
          </div>
        </div>
      </div>
    </div>

    <a
      href="whatsapp://send?phone=+522228230661"
      alt="Boton WhatsApp"
      className="float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label={"WhatsApp"}
    >
      <i className="fab fa-whatsapp my-float"></i>
    </a>
  </footer>
);

export default Footer;
